import { useEffect, useState } from "react";
import { MessageCircle, Phone, ArrowUp } from "lucide-react";
import { useCompany, toTelHref, toWhatsAppHref } from "@/lib/useCompany";
import { useSiteContent } from "@/lib/useSiteContent";

export default function FloatingActions() {
  const company = useCompany();
  const site = useSiteContent();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 640);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed right-4 bottom-20 xl:bottom-6 z-30 flex flex-col gap-2" data-testid="floating-contact-actions">
      {showTop && (
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="floating-action bg-zinc-900/90 text-zinc-100" aria-label={site.floating_top_label}
          title={site.floating_top_label} data-testid="floating-scroll-top">
          <ArrowUp size={18}/>
        </button>
      )}
      <a href={toTelHref(company.phone)} className="floating-action bg-[#0055FF] text-white"
        aria-label={site.floating_phone_label} title={site.floating_phone_label} data-testid="floating-phone">
        <Phone size={18}/>
      </a>
      <a href={toWhatsAppHref(company.whatsapp)} target="_blank" rel="noreferrer"
        className="floating-action bg-emerald-500 text-zinc-950"
        aria-label={site.floating_whatsapp_label} title={site.floating_whatsapp_label} data-testid="floating-whatsapp">
        <MessageCircle size={19}/>
      </a>
    </div>
  );
}
